var React = require('react');
var ReactDOM = require('react-dom');

var dialogControllerFactory = require('./factory.js');

var css = require('./module.scss');
var idSub = "__caih_fireplug_dialog__";

/**
 * 使用方法：
 * <Dialog visible={this.state.dialog.visible}>
        I am Dialog
    </Dialog>
 */

var DialogWrap = React.createClass({
    getInitialState: function() {
        var id = idSub + parseInt(new Date().getTime() / 10000, 10) + parseInt(Math.random() * 1000, 10);
        return {
            dialogController: dialogControllerFactory(id)
        };
    },
    componentDidMount: function() {
        this.componentWillReceiveProps(this.props);
    },
    componentWillReceiveProps: function(nextProps) {
        var cls = ['fp-dialog-content', nextProps.wrapClassName];
        this.state.dialogController.renderDialog({
            content: <div className={cls.join(' ')}
                style={nextProps.style}
                onClick={function(e) {
                    e.stopPropagation();
                }}>
                {nextProps.children}
            </div>,
            visible: nextProps.visible,
            wrapClassName: 'fp-modal',
            mask: true,
            onMaskClick: nextProps.onMaskClick
        });
    },
    render: function() {
        return <div style={{
            display: 'none'
        }}></div>;
    }
});

var id = idSub + parseInt(new Date().getTime() / 10000, 10) + parseInt(Math.random() * 1000, 10);
var dialogController = dialogControllerFactory(id);
DialogWrap.show = function(config) {

    if (typeof config == 'string') {
        config = {
            content: config
        };
    }

    var cls = ['fp-dialog-content', config.wrapClassName];
    dialogController.renderDialog({
        content: <div className={cls.join(' ')}
            style={config.style}
            onClick={function(e) {
                e.stopPropagation();
            }}>
            {config.content}
        </div>,
        visible: 1,
        wrapClassName: 'fp-modal',
        mask: true,
        onMaskClick: config.onMaskClick
    });

    return {
        destroy: function() {
            dialogController.destroy();
        }
    };
};

module.exports = DialogWrap;



// WEBPACK FOOTER //
// ./component/dialog/dialog.js